import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { IGetTiktokPostsData } from '../../Models/ITiktokPost';
import { TiktokCommentDto, ITiktokComment } from '../../Models/ITiktokComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { TiktokService } from '../../Services/tiktok.service';


@Component({
  selector: 'app-tiktok-comments',
  templateUrl: './tiktok-comments.component.html',
  styleUrl: './tiktok-comments.component.scss'
})
export class TiktokCommentsComponent  implements OnInit {
  @Input() postId?: string;
  comments: Array<ITiktokComment> = [];
  isLoadingComments = false;
  commentCount: number = 0;
  errorComments: string = ''

  error: string = '';

  constructor(
    private tiktokService: TiktokService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId)
      this.loadComments();
    else
      this.error = 'No post ID provided';
  }



  loadComments(): void {
    this.isLoadingComments = true;
    this.errorComments = '';
    
    this.tiktokService.getPostComments(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoadingComments = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.comments = Array.isArray(response) ? response : [response];
            this.commentCount = this.comments.length;
          } else {
            this.errorComments = 'No comments found or invalid response format';
            console.warn('No comments data in response:', response);
          }
        },
        error: (error) => {
          this.errorComments = 'Failed to load comments. Please try again.';
          console.error('Error loading comments:', error);
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

 
 getInitials(fullName: string): string {
   return HelperFunctions.getInitials(fullName);
 }
}